import { IconA1, IconA2, IconA3, IconA4, IconB1, IconB2, IconB3, IconB4, IconC1, IconC2, IconC3, IconC4, IconD1, IconD2, IconD3, IconD4 } from './icons';

interface ConfigItemIprops {
    icon: () => JSX.Element;
    name: string;
    time: string;
    unit: string;
    prefix?: string;
}
export const getJpIconList: (tab: string) => ConfigItemIprops[] = (tab: string) => {
    if (tab === 'a') {
        return [
            {
                icon: IconA1,
                name: '電気毛布 \n(120W)',
                time: '14.6',
                unit: '時間',
            },
            {
                icon: IconA2,
                name: '扇風機 \n(40W)',
                time: '43.8',
                unit: '時間',
            },
            {
                icon: IconA3,
                name: '電気ケトル \n(1,500W)',
                time: '1.2',
                unit: '時間',
            },
            {
                icon: IconA4,
                name: 'コーヒーメーカー \n(1,000W)',
                time: '1.8',
                unit: '時間',
            },
        ];
    }
    if (tab === 'b') {
        return [
            {
                icon: IconB1,
                name: 'スマホ \n(11W)',
                time: '159',
                unit: '回分',
            },
            {
                icon: IconB2,
                name: 'テレビ \n(110W)',
                time: '16',
                unit: '時間',
            },
            {
                icon: IconB3,
                name: '炊飯器\n(1,000W)',
                time: '1.8',
                unit: '時間',
            },
            {
                icon: IconB4,
                name: '電子レンジ \n(1,300W)',
                time: '1.3',
                unit: '時間',
            },
        ];
    }
    if (tab === 'c') {
        return [
            {
                icon: IconC1,
                name: 'カメラ \n(16Wh)',
                time: '109',
                unit: '回分',
                // prefix: '充電',
            },
            {
                icon: IconC2,
                name: 'パソコン\n(60W)',
                time: '29',
                unit: '回分',
                // prefix: '充電',
            },
            {
                icon: IconC3,
                name: 'プロジェクター\n(65W)',
                time: '27',
                unit: '時間',
            },
            {
                icon: IconC4,
                name: 'IH \n(1,500W)',
                time: '1.2',
                unit: '時間',
            },
        ];
    }
    if (tab === 'd') {
        return [
            {
                icon: IconD1,
                name: '電気ドリル \n(1,080W)',
                time: '1.6',
                unit: '時間',
            },
            {
                icon: IconD2,
                name: '切断機\n(1,100W)',
                time: '1.6',
                unit: '時間',
            },
            {
                icon: IconD3,
                name: '丸ノコ \n(1,400W)',
                time: '1.3',
                unit: '時間',
            },
            {
                icon: IconD4,
                name: 'ハンマードリル\n（1,200W）',
                time: '1.5',
                unit: '時間',
            },
        ];
    }
    return [];
};
